import Mutations from '../../odata/mutations';

export default { ...new Mutations('employee'), ...new Mutations('employees') };
